export default __webpack_public_path__ + "static/sac.inspirations-47668073e99bc4fdb6a6ce090dcdfcf5.jpg";